export default "__VITE_ASSET__BFIasxpY__"